/* tslint:disable */
/* eslint-disable prettier/prettier */ 
export const introspectionQueryResultData = {
  "__schema": {
    "types": []
  }
}
          